import { ref } from 'vue';
import { clientsAPI, type Client } from '../services/api';
import { getI18nT } from '../i18n';

const clients = ref<Client[]>([]);
const isLoading = ref(false);
const error = ref<string | null>(null);
const currentPage = ref(1);
const totalCount = ref(0);
const hasMore = ref(true);
const currentSearch = ref('');

export function useClients() {
  const fetchClients = async (page = 1, limit = 10, search?: string): Promise<boolean> => {
    if (search !== undefined) {
      currentSearch.value = search;
    }

    isLoading.value = true;
    error.value = null;

    try {
      const res = await clientsAPI.getAll(page, limit, currentSearch.value || undefined);
      const { data, total } = res.data;

      clients.value = page === 1 ? data : [...clients.value, ...data];
      currentPage.value = page;
      totalCount.value = total;
      hasMore.value = clients.value.length < total;

      return true;
    } catch (err: any) {
      const t = getI18nT();
      error.value = err.response?.data?.message || t('composables.clients.error_fetch');
      return false;
    } finally {
      isLoading.value = false;
    }
  };

  const clearClients = () => {
    clients.value = [];
    currentPage.value = 1;
    totalCount.value = 0;
    hasMore.value = true;
    currentSearch.value = '';
  };

  return {
    clients,
    isLoading,
    error,
    currentPage,
    totalCount,
    hasMore,
    currentSearch,
    fetchClients,
    clearClients,
  };
}
